import http, { girderApi } from '@/http';

const GirderProvider = {
  girderRest: http,
  girderApi,
};
export default GirderProvider;
